import React from 'react'
import styles from '../../../css/services/conServices.module.css'
function CivilDefense() {
    return (
        <div className={styles.container}>
            <div className={styles.services}>
                <div>
                    <h1>1. إصدار رخصة الدفاع المدني Issuance of Civil Defense license</h1>
                    <p>
                        خدمة للحصول على تصريح من الدفاع المدني يثبت أن
                        <br />
                        المنشأة تلتزم بالمعايير الأمانية وتتبع الإجراءات الضرورية
                        <br/>
                        للحماية من المخاطر

                    </p>
                </div>
                <div>
                    <h1>2. تجديد رخصة الدفاع المدني (Renewal of Civil Defense license)</h1>
                    <p>
                        إمكانية تجديد التصريح الصادر من الدفاع المدني للتأكد من
                        <br/>
                        استمرار التزام المنشأة بمعايير السلامة والحماية
                    </p>
                </div>
            </div>
        </div>
  )
}

export default CivilDefense